<template>
  <div class="bill-export-container">
    <div class="header">
      <div class="title">对账单导出</div>
    </div>
    <div class="param-form">
      <el-form
        inline
        :model="paramForm"
        label-width="100px"
        label-position="left"
        ref="form"
        class="param-form-content"
      >
        <el-row>
          <el-form-item label="交易创建时间" size="small">
            <DateTimeRangePicker
              ref="dateRangePicker"
              maxRange="32 day"
              type="daterange"
              :earliestDate="earliestDate"
              :latestDate="latestDate"
              :startTime.sync="paramForm.startTime"
              :endTime.sync="paramForm.endTime"
              :shortcutArr="['昨天', '上周', '上月']"
            />
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="所属门店" size="small">
            <CommonSelect
              v-model="paramForm.shopIds"
              :needAll="true"
              :options="shopOptions"
              :isMultiple="true"
              :needPaging="true"
              :pageLoading="shopPageInfo.loading"
              @loadmore="queryShopList"
            />
          </el-form-item>
          <el-form-item label="分时日切节点" size="small" style="margin-left: 20px;">
            <el-select v-model="checkStartTime" placeholder="请选择">
              <el-option v-for="i in numList" :key="i.value" :label="i.label" :value="i.value"/>
            </el-select>
          </el-form-item>
        </el-row>
      </el-form>
      <el-row class="centered-row">
        <el-button :loading="exportLoading[0]" @click="handleExport(0)" class="bs-btn">导出汇总账单</el-button>
        <!-- 导出结算订单明细和费用明细的导出是同一个接口 -->
        <el-button :loading="exportLoading[1]" @click="handleExport(1)" class="bs-btn">导出结算订单明细</el-button>
        <el-button :loading="exportLoading[2]" @click="handleExport(2)" class="bs-btn">导出活动对账单</el-button>
        <el-button :loading="exportLoading[3]" @click="handleExport(3)" class="bs-btn bs-btn3">
            导出统计数据<br>
            <div style="font-size: 10px;">（收款-完成时间、退款-创建时间）</div>
        </el-button>
        <el-button @click="handleFormReset" class="bs-btn2">重置</el-button>
      </el-row>
    </div>
    <div class="txt">
      <div v-for="(item, index) in txtItems" :key="index" class="txt-item">
        <div class="title">{{ item.title }}</div>
        <div class="content" v-html="item.content"></div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import DateTimeRangePicker from '@/components/dateTimeRangePicker.vue';
import CommonSelect from '@/components/CommonSelect.vue';
import { exportBill, exportActivityBill, exportReconciliationShort } from '@/api/bill-export';
import { exportCostDetail } from '@/api/expense-details';
import { queryShopList } from "@/api/merchant-info";

export default {
  name: 'bill-export',
  components: {
    DateTimeRangePicker,
    CommonSelect,
  },
  data() {
    return {
      earliestDate: moment('2022-08-01').startOf('day'),
      latestDate: moment().subtract(1, 'day').endOf('day'),
      checkStartTime: 0, // 分时开始时间
      shopPageInfo: {
        loading: false,
        pageNo: 1,
        finished: false,
        pageSize: 30,
      },
      paramForm: {
        startTime: '',
        endTime: '',
        shopIds: ['all'],
      },
      shopOptions: [],
      numList: Array(24).fill(0).map((v, i) => ({ label: `${i}点`, value: i })), // 日切选项
      exportLoading: [false, false, false, false],
      txtItems: [
        {
          title: '操作提示：',
          content: `1、支持导出2022年8月1日以后的数据，选择时间周期跨度最长不超过32天。<br>
                    2、每天早上9点后，才可导出前一天的账单，若需查询或导出实时交易数据，请移步【实时交易】页面查询或导出。<br>
                    3、操作步骤：选择时间 >> 点击导出对账单(生成对账单文件) >> 在【下载中心】页面选择已生成的文件，点击下载。`,
        },
        {
          title: '账单说明：',
          content: `1、点击【导出汇总账单】按钮，将同时导出汇总报表、门店汇总报表、设备汇总报表及结算明细。<br>
                    2、【导出汇总账单】，其中数据按交易完成时间统计；【导出统计数据】其中收款订单按完成时间统计，退款订单按创建时间统计。<br>
                    3、所有的交易方式(扫码、刷卡、数币等)，收款成功、退款成功均各计一笔交易，部分退款的情况，每退一次，计一笔退款笔数。<br>
                    4、预授权、预授权撤销的订单，不计入交易笔数及入实收金额，也不涉及费用计算；预授权完成，预授权完成撤销计入笔数及实收金额。`,
        },
        {
          title: '分时日切节点设置说明：',
          content: `1、分时日切节点默认为0点，即每日数据统计周期为当天的00:00:00-23:59:59，若选择日切节点为6点，则导出账单中，每天的汇总统计周期为当天的06:00:00-次日05:59:59。<br>
                    2、若设置分时日切节点晚于9点时，可导出账单的时间顺延，例如：分时节点设置为10点，则1号的账单，需在2号早上10点后才可导出。`,
        },
      ],
    };
  },
  mounted() {
    this.queryShopList();
  },
  methods: {
    queryShopList() {
      const { pageNo, finished, pageSize } = this.shopPageInfo;
      if (finished) return false;
      const params = {
        userName: "",
        merchantName: "",
        merchantId: "",
        pageNo,
        pageSize,
      };
      this.shopPageInfo.loading = true;
      queryShopList(params).then(({ data }) => {
        this.shopPageInfo.loading = false;
        if (String(data.error_code) === '0') {
          const newList = data.data.list.map(i => ({ label: `${i.merchantName} ${i.shopId}`, value: i.merchantId }));
          this.shopOptions = [...this.shopOptions, ...newList];
          if (newList.length < pageSize) {
            this.shopPageInfo.finished = true;
          } else {
            this.shopPageInfo.pageNo += 1;
          }
        }
      });
      return true;
    },

    // 重置
    handleFormReset() {
      this.$refs.dateRangePicker.handleQuickTimePickerChange(0);
      this.paramForm.shopIds = ['all'];
      this.checkStartTime = 0;
    },

    /**
     * 导出
     * @param {Number} index 导出按钮序号
     */
    handleExport(index) {
      // 日切处理
      if (this.checkStartTime >= 9 && moment(this.paramForm.endTime).valueOf() >= moment().subtract(1, 'day').startOf('day').valueOf()) {
        if (moment().hour() < this.checkStartTime) {
          this.$message.warning(`导出账单包括昨日账单，请${this.checkStartTime}点后再导出。`);
          return;
        }
      }
      const formatHour = hour => (hour < 10 ? `0${hour}` : hour);
      const startTime = `${this.paramForm.startTime} ${formatHour(this.checkStartTime)}:00:00`;
      // const endTime = `${moment(this.paramForm.endTime).add(1, 'day').format('yyyy-MM-DD')} ${formatHour(this.checkStartTime)}:00:00`;
      let endTime;
      if (this.checkStartTime > 0) {
        endTime = `${moment(this.paramForm.endTime).add(1, 'day').format('yyyy-MM-DD')} ${formatHour(this.checkStartTime - 1)}:59:59`;
      } else {
        endTime = `${moment(this.paramForm.endTime).format('yyyy-MM-DD')} 23:59:59`;
      }

      const { merchantId } = JSON.parse(localStorage.getItem('LOGIN_INFO'));
      const { shopIds } = this.paramForm;
      const params = {
        merchantId,
        startTime,
        endTime,
      };
      if (index === 1) { // 使用费用明细的参数名称
        params.shopIds = shopIds.filter(v => v !== 'all');
      } else { // 对账单的参数名称
        params.shopRangeType = shopIds.includes('all') ? 'allShop' : 'singleShop';
        params.targetMerchantIds = shopIds.filter(v => v !== 'all');
        params.startHour = this.checkStartTime; // 日切
      }

      const apiList = [exportBill, exportCostDetail, exportActivityBill, exportReconciliationShort];
      const api = apiList[index];
      this.$set(this.exportLoading, index, true);
      api(params).then(({ data: { code, msg } }) => {
        this.$set(this.exportLoading, index, false);
        if (String(code) === '0') {
          this.$message.success('导出成功，请到下载中心下载文件！');
        } else {
          this.$message.error(msg);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.bill-export-container {
  .header {
    padding-left: 50px;
    background-color: #fff;

    .title {
      position: relative;
      height: 80px;
      font-size: 18px;
      line-height: 80px;
      color: #333;

      &::after {
        position: absolute;
        right: 0;
        bottom: 0;
        left: -50px;
        display: block;
        height: 0;
        content: "";
        border-bottom: 1px solid #f2f3f3;
      }
    }
  }

  .param-form {
    padding: 40px 50px 20px;

    .param-form-content {
      /deep/ .el-select,
      /deep/ .el-input {
        width: 210px;
      }
    }

    .centered-row {
      display: flex;
      align-items: center; /* 垂直居中 */
    }
  }

  .txt {
    padding: 20px 50px;

    .txt-item {
      margin-bottom: 30px;
      font-weight: 500;
      line-height: 27px;

      .title {
        font-size: 18px;
        color: #27364d;
      }

      .content {
        font-size: 14px;
        color: #a6a6ae;
      }
    }
  }
}

/deep/ .el-select__tags-text {
  width: auto;
  max-width: 100px;
}

/deep/ .el-range-separator {
  width: 40px;
}
</style>
